import get from 'lodash.get';

const getCreatedWithCleanUrlsDisabled = (rootState) =>
  get(rootState, 'ws.site.properties.createdWithCleanUrlsDisabled', false);

export default getCreatedWithCleanUrlsDisabled;
